export default "__VITE_ASSET__BTLindn7__"